import type { command } from "@codesandbox/pitcher-protocol";
import { usePitcher } from "features/utils/usePitcher";
import * as React from "react";

export const usePitcherCommands = (): {
  commands: command.ICommand[];
  execute: ((commandId: string) => Promise<void>) | null;
} => {
  const pitcher = usePitcher();
  const hasCommandExecuteAccess = pitcher.permissions.command?.execute;

  const [commands, setCommands] = React.useState(
    pitcher.clients.command.getCommands(),
  );

  React.useEffect(() => {
    const disposable = pitcher.clients.command.onCommandsUpdated(
      (newCommands) => setCommands(newCommands),
    );

    return () => {
      disposable.dispose();
    };
  }, []);

  return {
    commands,
    // TODO: we use `command.execute` permission to determine whether the client has access to execute pitcher
    // commands, but this is not the best way to do it. Ideally Pitcher decides this, and only sends the
    // commands that the client has access to.
    execute: hasCommandExecuteAccess
      ? pitcher.clients.command.executeCommand.bind(pitcher.clients.command)
      : null,
  };
};
